import React, { useEffect, useState } from "react";
import { HelpdeskRecipesAPI } from "../api/helpdeskRecipes";

export default function RunRecipeModal({ open, ticketId, onClose, onRun, title = "Run recipe" }) {
  const [recipes, setRecipes] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [loading, setLoading] = useState(false);
  const [running, setRunning] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open || !ticketId) return;
    let active = true;
    setRecipes([]);
    setSelectedId("");
    setError("");
    setLoading(true);
    HelpdeskRecipesAPI.availableForTicket(ticketId)
      .then((data) => { if (active) setRecipes(Array.isArray(data?.recipes) ? data.recipes : []); })
      .catch((err) => { if (active) setError(err.message || "Unable to load recipes"); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [open, ticketId]);

  if (!open) return null;
  const selected = recipes.find((r) => String(r.id) === selectedId);

  async function confirm() {
    if (!selected || running) return;
    setRunning(true);
    setError("");
    try {
      await onRun(selected.id);
      onClose();
    } catch (err) {
      setError(err.message || "Recipe could not be completed");
    } finally {
      setRunning(false);
    }
  }

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4" role="presentation">
      <div role="dialog" aria-modal="true" aria-label={title} className="w-full max-w-lg rounded-lg border border-[var(--nj-border)] bg-[var(--nj-surface)] p-5 text-[var(--nj-text)] shadow-xl">
        <h2 className="mb-3 text-lg font-semibold">{title}</h2>
        {loading ? <p>Loading available recipes…</p> : (
          <>
            <label htmlFor="nj-recipe-select" className="mb-1 block text-sm font-medium">Recipe</label>
            <select id="nj-recipe-select" className="nj-ticket-control w-full rounded border border-[var(--nj-border)] bg-[var(--nj-surface)] p-2 text-[var(--nj-text)]" value={selectedId} onChange={(e) => setSelectedId(e.target.value)} disabled={running}>
              <option value="">Select a recipe…</option>
              {recipes.map((r) => <option key={r.id} value={String(r.id)}>{r.name}</option>)}
            </select>
            {recipes.length === 0 && <p className="mt-2 text-sm">No recipes are available for this ticket.</p>}
            {selected?.description && <p className="mt-3 text-sm">{selected.description}</p>}
            <p className="mt-3 text-xs opacity-75">The recipe may change this ticket or send notifications. Confirm before running.</p>
          </>
        )}
        {error && <p role="alert" className="mt-3 text-sm text-red-500">{error}</p>}
        <div className="mt-5 flex justify-end gap-2">
          <button type="button" className="rounded border border-[var(--nj-border)] px-3 py-2" disabled={running} onClick={onClose}>Cancel</button>
          <button type="button" className="rounded bg-blue-600 px-3 py-2 text-white disabled:opacity-50" disabled={!selected || running || loading} onClick={confirm}>{running ? "Working…" : "Confirm"}</button>
        </div>
      </div>
    </div>
  );
}
